import {
  OPERATOR_TYPES_1,
  OPERATOR_TYPES_3,
} from 'dashboard/components/widgets/FilterInput/FilterOperatorTypes.js';

// Custom operator types for Orders
const NUMERIC_OPERATOR_TYPES = [
  { value: 'equal_to', label: 'Equal to' },
  { value: 'not_equal_to', label: 'Not equal to' },
  { value: 'less_than', label: 'Less than' },
  { value: 'greater_than', label: 'Greater than' },
];

const DATE_OPERATOR_TYPES = [
  { value: 'is_on', label: 'Is on' },
  { value: 'is_after', label: 'Is after' },
  { value: 'is_before', label: 'Is before' },
];

const filterTypes = [
  {
    attributeKey: 'external_order_id',
    attributeI18nKey: 'ORDER_ID',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'buyer_name',
    attributeI18nKey: 'BUYER',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'product_identifier',
    attributeI18nKey: 'SKU',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'inbox_id',
    attributeI18nKey: 'SHOP',
    inputType: 'multi_select',
    dataType: 'number',
    filterOperators: OPERATOR_TYPES_1,
    attribute_type: 'standard',
    options: [], // will be populated dynamically from store
  },
  {
    attributeKey: 'source',
    attributeI18nKey: 'SOURCE',
    inputType: 'multi_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_1,
    attribute_type: 'standard',
    options: [
      { id: 'etsy', name: 'Etsy' },
      { id: 'tiktok', name: 'TikTok' },
      { id: 'shopee', name: 'Shopee' },
      { id: 'lazada', name: 'Lazada' },
      { id: 'kimkieuflower', name: 'Kim Kiều Flower' },
    ],
  },
  {
    attributeKey: 'status',
    attributeI18nKey: 'STATUS',
    inputType: 'multi_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_1,
    attribute_type: 'standard',
    options: [
      { id: 'pending', name: 'Pending' },
      { id: 'processing', name: 'Processing' },
      { id: 'shipped', name: 'Shipped' },
      { id: 'delivered', name: 'Delivered' },
      { id: 'cancelled', name: 'Cancelled' },
      { id: 'refunded', name: 'Refunded' },
    ],
  },
  {
    attributeKey: 'total_cents',
    attributeI18nKey: 'TOTAL',
    inputType: 'plain_text',
    dataType: 'number',
    filterOperators: NUMERIC_OPERATOR_TYPES,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'placed_at',
    attributeI18nKey: 'PLACED_AT',
    inputType: 'date',
    dataType: 'date',
    filterOperators: DATE_OPERATOR_TYPES,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'has_conversation',
    attributeI18nKey: 'HAS_CONVERSATION',
    inputType: 'multi_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_1,
    attribute_type: 'standard',
    options: [
      { id: 'yes', name: 'Has conversation' },
      { id: 'no', name: 'No conversation' },
    ],
  },
];

export default filterTypes;
